import { h } from 'preact'
import { tagParser } from '../../js/modules/utilities.js'
import img1 from './images/perso-reco_img1.png'
import img2 from './images/perso-reco_img2.png'
import img3 from './images/perso-reco_img3.png'

export const PersoReco = ({ title, items }) => {
   let badgeClassColor = 'badge-jaune'
   if (items[2].badge.bgcolor === 'noir') badgeClassColor = 'badge-noir'
   if (items[2].badge.bgcolor === 'blanc') badgeClassColor = 'badge-blanc'

   return (
      <div class="container-fluid">
         <div class="perso-reco row" data-testid="bande-reco-perso">
            <div class="col-12">
               <h2 class="mw-100">{title}</h2>
            </div>
            <div class="col-6 col-md-3 mb-2 mb-lg-4">
               <Card {...items[0]} />
            </div>
            <div class="col-6 col-md-3 mb-2 mb-lg-4">
               <Card {...items[1]} />
            </div>
            <div class="col-12 col-md-6 mb-2 mb-lg-4">
               <a
                  href={items[2].CTA.URL}
                  class="banner"
                  data-pdb-zid={items[2].CTA.analytics.pdbZid}
                  data-pdb-sc={items[2].CTA.analytics.pdbSc}
                  data-pdb-idc={items[2].CTA.analytics.pdbIdc}
                  data-pdb-vi={items[2].CTA.analytics.pdbVi}
                  data-oevent-category={items[2].CTA.analytics.oeventCategory}
                  data-oevent-action={items[2].CTA.analytics.oeventAction}
                  data-oevent-label={items[2].CTA.analytics.oeventLabel}
                  data-oevent-other={items[2].CTA.analytics.oeventOther}
               >
                  {items[2].badge.label !== '' ? <strong class={`badge ob1-tag ${badgeClassColor}`}>{items[2].badge.label}</strong> : ''}
                  <span class="title" dangerouslySetInnerHTML={{ __html: tagParser(items[2].CTA.label) }}></span>
                  <img class="banner-img" src={items[2].image} alt="" loading="lazy" />
               </a>
            </div>
         </div>
      </div>
   )
}

const Card = ({ CTA, title, image }) => {
   return (
      <a
         href={CTA.URL}
         class="ob1-card d-flex flex-column h-100"
         data-pdb-zid={CTA.analytics.pdbZid}
         data-pdb-sc={CTA.analytics.pdbSc}
         data-pdb-idc={CTA.analytics.pdbIdc}
         data-pdb-vi={CTA.analytics.pdbVi}
         data-oevent-category={CTA.analytics.oeventCategory}
         data-oevent-action={CTA.analytics.oeventAction}
         data-oevent-label={CTA.analytics.oeventLabel}
         data-oevent-other={CTA.analytics.oeventOther}
      >
         <img src={image} alt="" class="card-img-top w-100" loading="lazy" />
         <div class="p-1 p-lg-2 text-center">
            <h3 class="card-title p-0" dangerouslySetInnerHTML={{ __html: tagParser(title) }}></h3>
            <span class="cta mt-auto mw-100 o-link-arrow">{CTA.label}</span>
         </div>
      </a>
   )
}
